import { o_global } from "@gr-common/head/namespaces";
import { eventLoader, EventLoader } from "./Loader.js";

export { EventLoader, eventLoader };

o_global.EventLoader ||= EventLoader;
o_global.eventLoader ||= eventLoader();
